<template>
  <div class="missing block content">
    <p class="mb-4">Any missing extracts for this day will appear in this section.</p>
    <div class="modern-grid">
      <component
        v-for="component in componentsList"
        :is="component.comp"
        :key="component.name"
        :scanResults="scanResults"
      />
    </div>
  </div>
</template>

<script>
import AaaBowel from './clinicalapps/AaaBowel'
import ChoosePharmacy from './clinicalapps/ChoosePharmacy.vue'
import Cypris from './clinicalapps/Cypris.vue'
import DemoChoosePharmacy from './clinicalapps/DemoChoosePharmacy.vue'
import DemoGp from './clinicalapps/DemoGp.vue'
import Esr from './clinicalapps/Esr.vue'
import Wcp from './clinicalapps/Wcp.vue'
import WcpMobile from './clinicalapps/WcpMobile.vue'
import Wds from './clinicalapps/Wds.vue'
import Wis from './clinicalapps/Wis.vue'
import Wpas from './clinicalapps/Wpas.vue'

export default {
  components: {
    AaaBowel,
    ChoosePharmacy,
    DemoChoosePharmacy,
    Cypris,
    Esr,
    DemoGp,
    Wcp,
    WcpMobile,
    Wds,
    Wis,
    Wpas,
  },
  props: {
    scanResults: Array
  },
  computed: {
    componentsList() {
      return [
        { name: 'AaaBowel', comp: 'AaaBowel' },
        { name: 'ChoosePharmacy', comp: 'ChoosePharmacy' },
        { name: 'DemoChoosePharmacy', comp: 'DemoChoosePharmacy' },
        { name: 'Cypris', comp: 'Cypris' },
        { name: 'Esr', comp: 'Esr' },
        { name: 'DemoGp', comp: 'DemoGp' },
        { name: 'Wcp', comp: 'Wcp' },
        { name: 'WcpMobile', comp: 'WcpMobile' },
        { name: 'Wds', comp: 'Wds' },
        { name: 'Wis', comp: 'Wis' },
        { name: 'Wpas', comp: 'Wpas' }
      ]
    }
  }
}
</script>

<style scoped>
.modern-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}
</style>